module.exports = __webpack_public_path__ + "static/img/image066.f012b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image066.png
// module id = 7rTM
// module chunks = 1